import React from "react";

const TONES = {
    low: "border-slate-200 bg-slate-50 text-slate-700",
    medium: "border-amber-200 bg-amber-50 text-amber-800",
    high: "border-orange-200 bg-orange-50 text-orange-800",
    urgent: "border-rose-300 bg-rose-50 text-rose-800",
};

const PriorityPill = ({ priority }) => {
    const tone = TONES[priority] || TONES.medium;
    return (
        <span
            data-testid={`priority-pill-${priority || "unknown"}`}
            className={`inline-flex items-center rounded-full border px-2 py-0.5 text-[10px] font-semibold uppercase tracking-wider ${tone}`}
        >
            {priority || "—"}
        </span>
    );
};

export default PriorityPill;
